module.exports = {
  DEFAULTER: 'DEFAULTER',
  COMPLIANCE: 'COMPLIANCE',
  END_OF_RELATIONSHIP: 'END_OF_RELATIONSHIP',
  OTHERS: 'OTHERS'
};
